import React, { useEffect, useRef, useState } from "react";
import "./satisfiedcustomers.css";

const SatisfiedCustomers = () => {
    const statsData = [
        { value: 10000, suffix: "+", label: "Happy Customers", icon: "😊" },
        { value: 100, suffix: "+", label: "Banking Partners", icon: "🏦" },
        { value: 500, suffix: " Cr+", label: "Loans Disbursed", icon: "💰" },
        { value: 4.9, suffix: "★", label: "Customer Rating", icon: "⭐" },
    ];

    const StatsSection = () => {
        const sectionRef = useRef(null);
        const [startCount, setStartCount] = useState(false);

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setStartCount(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.4 }
            );

            if (sectionRef.current) observer.observe(sectionRef.current);
            return () => observer.disconnect();
        }, []);

        return (
            <section className="sc-stats" ref={sectionRef}>
                {statsData.map((stat, index) => (
                    <StatCard key={index} stat={stat} start={startCount} />
                ))}
            </section>
        );
    };

    const StatCard = ({ stat, start }) => {
        const [count, setCount] = useState(0);

        useEffect(() => {
            if (!start) return;

            let startValue = 0;
            const duration = 2000;
            const increment = stat.value / (duration / 16);

            const counter = setInterval(() => {
                startValue += increment;
                if (startValue >= stat.value) {
                    setCount(stat.value);
                    clearInterval(counter);
                } else {
                    setCount(startValue);
                }
            }, 16);

            return () => clearInterval(counter);
        }, [start, stat.value]);

        return (
            <div className="sc-stat-card" data-icon={stat.icon}>
                <span className="sc-stat-icon">{stat.icon}</span>
                <h2>
                    {stat.value === 4.9 ? count.toFixed(1) : Math.floor(count)}
                    {stat.suffix}
                </h2>
                <p>{stat.label}</p>
            </div>
        );
    };


    return (
        <div className="sc-page">
            {/* 1. HERO */}
            <section className="sc-hero">
                <h1>Thousands of Customers Trust Us</h1>
                <p>
                    Delivering reliable financial solutions with transparency, speed, and
                    customer satisfaction.
                </p>
            </section>

            {/* 2. TRUST HIGHLIGHTS */}
            <section className="sc-trust">
                <div className="sc-trust-card" data-icon="🛡️">
                    <span className="sc-trust-icon">🛡️</span>
                    <h4>RBI-Compliant Process</h4>
                    <p>Fully regulated and compliant with RBI guidelines.</p>
                </div>

                <div className="sc-trust-card" data-icon="⚡">
                    <span className="sc-trust-icon">⚡</span>
                    <h4>100% Digital Journey</h4>
                    <p>Apply, track, and approve loans completely online.</p>
                </div>

                <div className="sc-trust-card" data-icon="🔒">
                    <span className="sc-trust-icon">🔒</span>
                    <h4>Secure & Encrypted Data</h4>
                    <p>Your personal and financial data is always protected.</p>
                </div>

                <div className="sc-trust-card" data-icon="👨‍💼">
                    <span className="sc-trust-icon">👨‍💼</span>
                    <h4>Expert Financial Advisors</h4>
                    <p>Get guidance from certified loan specialists.</p>
                </div>
            </section>

            {/* CUSTOMER SUCCESS STORIES – TIMELINE STYLE */}
            <section className="sc-success-timeline">
                <div className="sc-success-header">
                    <h2>Customer Success Stories</h2>
                    <p>How our customers achieved their financial goals</p>
                </div>

                <div className="sc-timeline">
                    <div className="sc-timeline-item">
                        <div className="sc-timeline-number">01</div>
                        <div className="sc-timeline-content">
                            <h4>Home Loan Approved in 72 Hours</h4>
                            <p>
                                A salaried professional used our instant eligibility check and received
                                loan approval within just 3 days.
                            </p>
                            <span className="sc-timeline-tag">Home Loan</span>
                        </div>
                    </div>

                    <div className="sc-timeline-item">
                        <div className="sc-timeline-number">02</div>
                        <div className="sc-timeline-content">
                            <h4>Business Loan for Rapid Expansion</h4>
                            <p>
                                A small business owner secured funding at competitive rates to expand
                                operations across multiple cities.
                            </p>
                            <span className="sc-timeline-tag">Business Loan</span>
                        </div>
                    </div>

                    <div className="sc-timeline-item">
                        <div className="sc-timeline-number">03</div>
                        <div className="sc-timeline-content">
                            <h4>Instant Credit Card Approval</h4>
                            <p>
                                A first-time applicant received a premium credit card with zero
                                documentation and exclusive rewards.
                            </p>
                            <span className="sc-timeline-tag">Credit Card</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. CUSTOMER STATS */}
            <StatsSection />

            {/* 7. CTA */}
            <section className="sc-cta">
                <h2>Become Our Next Success Story</h2>
                <p>
                    Join thousands of satisfied customers and achieve your financial goals
                    today.
                </p>
                <button className="apply-btn">Apply Now</button>
            </section>
        </div>
    );
};

export default SatisfiedCustomers;
